import $ from 'jquery';

const defaults = {
  interval: undefined,
  columns: undefined,
  item: undefined,
  parent: undefined,
  divider: 'new-col',
  blockName: undefined,
};

function Columns(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.interval = this.settings.interval;
  this.columns = this.settings.columns;
  this.item = this.settings.item;
  this.parent = this.settings.parent;
  this.divider = this.settings.divider;
  this.blockName = this.settings.blockName;
  this.addIndexes = this.addIndexes.bind(this);
  this.total = this.numLinks();
  this.init();
}

Columns.prototype = {
  init() {
    const interval = (this.interval) ? this.interval : Math.ceil(this.total / this.columns);
    this.$element.find(`${this.item}:nth-child(${interval}n + 1)`).addClass(this.divider);
    if (this.parent) {
      this.$element.find(this.parent).addClass(`${this.blockName}-cols`);
    } else {
      this.$element.addClass(`${this.blockName}-cols`);
    }
    this.addIndexes();
    let i = 0;
    let c = 1;
    do {
      this.createCols(i, c);
      i += interval;
      c += 1;
    } while (i < this.total);
  },
  addIndexes() {
    this.$element.find(`${this.item}`).each((i, element) => {
      $(element).addClass(`id-${i + 1}`);
    });
  },
  createCols(i, c) {
    const id = i + 1;
    const stripe = (c % 2 === 0) ? 'even' : 'odd';
    this.$element.find(`.id-${id}`)
      .nextUntil(`.${this.divider}`)
      .addBack()
      .wrapAll(`<div class="${this.blockName}-col ${this.blockName}-col-${c} ${stripe}"></div>`);
  },
  numLinks() {
    return this.$element.find(this.item).length;
  },
};

export default Columns;
